import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLanguage } from "@/context/LanguageContext";
import { LogOut, User, Heart, ShieldCheck, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator
} from "@/components/ui/dropdown-menu";

const ADMIN_EMAIL = "alfredwinescom@gmail.com";

export default function Navbar() {
  const { user, logout } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();
  const isAdmin = user?.email?.toLowerCase() === ADMIN_EMAIL;
  const hasMarketplaceAccess =
    isAdmin ||
    (user?.membership?.active && ["premium", "business"].includes(user?.membership?.plan));

  return (
    <nav data-testid="navbar" className="fixed top-0 left-0 right-0 z-50 bg-wine-bg/80 backdrop-blur-xl border-b border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 h-16 flex items-center justify-between">
        <a href="https://alfredwine.com/" className="flex items-center gap-3 group" data-testid="nav-logo">
          <span className="bg-white rounded-md px-2 py-0.5 flex items-center">
            <img
              src="/logo-text.png"
              alt="AlfredWine.com · Global Wine Ratings"
              data-testid="nav-logo-img"
              className="h-10 sm:h-12 w-auto object-contain"
            />
          </span>
        </a>

        <div className="flex items-center gap-8">
          {/* Wines dropdown — REMOVED per user request */}

          {/* Club dropdown — REMOVED per user request */}

          {user ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="sm" data-testid="nav-user-menu" className="text-white/60 hover:text-white hover:bg-white/5 gap-2 font-body text-sm">
                  <User className="w-4 h-4" />
                  {user.name}
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="bg-wine-paper border-white/10 min-w-[180px]">
                <DropdownMenuItem className="text-white/70 text-sm font-body pointer-events-none">{user.email}</DropdownMenuItem>
                <DropdownMenuSeparator className="bg-white/10" />
                <DropdownMenuItem
                  data-testid="nav-profile"
                  onClick={() => navigate("/profile")}
                  className="text-white/70 hover:text-white cursor-pointer font-body text-sm"
                >
                  <Heart className="w-4 h-4 mr-2" /> Profile &amp; Favorites
                </DropdownMenuItem>
                {isAdmin && (
                  <DropdownMenuItem
                    data-testid="nav-admin"
                    onClick={() => navigate("/admin")}
                    className="text-gold hover:text-gold cursor-pointer font-body text-sm"
                  >
                    <ShieldCheck className="w-4 h-4 mr-2" /> Admin Panel
                  </DropdownMenuItem>
                )}
                <DropdownMenuSeparator className="bg-white/10" />
                <DropdownMenuItem data-testid="nav-logout" onClick={() => { logout(); navigate("/"); }} className="text-merlot-light cursor-pointer font-body text-sm">
                  <LogOut className="w-4 h-4 mr-2" /> {t.signOut}
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <Link to="/login">
              <Button data-testid="nav-login" variant="ghost" size="sm" className="text-white/60 hover:text-white hover:bg-white/5 font-body text-sm tracking-wide">
                {t.signIn}
              </Button>
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}
